import { BookOpen, FileText, Mail, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-background border-t border-gray-200">
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 text-left">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-saas-navy mb-4 text-left">
              FlatJive
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed text-left">
              FlatJive is the complete platform to centralise leasehold management across all stakeholders.
            </p>
            <a 
              href="https://www.linkedin.com/company/flatjive" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-saas-blue hover:text-blue-600 transition-colors"
              aria-label="Follow FlatJive on LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
          </div>

          {/* Product Column */}
          <div>
            <h3 className="text-lg font-bold text-saas-navy mb-4 text-left">
              Product
            </h3>
            <ul className="space-y-3 text-left">
              <li>
                <Link to="/insights/" className="text-gray-600 hover:text-saas-blue transition-colors py-2 inline-block">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/pricing/" className="text-gray-600 hover:text-saas-blue transition-colors py-2 inline-block">
                  Pricing
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-saas-blue transition-colors py-2 inline-block">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-bold text-saas-navy mb-4 text-left">
              Company
            </h3>
            <ul className="space-y-3 text-left">
              <li>
                <Link to="/privacy/" className="text-gray-600 hover:text-saas-blue transition-colors flex items-center py-2">
                  <FileText className="h-4 w-4 mr-2" />
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms/" className="text-gray-600 hover:text-saas-blue transition-colors flex items-center py-2">
                  <FileText className="h-4 w-4 mr-2" />
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/cookies/" className="text-gray-600 hover:text-saas-blue transition-colors flex items-center py-2">
                  <FileText className="h-4 w-4 mr-2" />
                  Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold text-saas-navy mb-4 text-left">
              Contact
            </h3>
            <p className="text-gray-600 mb-4 leading-relaxed text-left">
              Have questions? Get in touch with our support team.
            </p>
            <a href="mailto:support@flatjive.com" className="inline-flex items-center text-saas-blue hover:text-blue-600 transition-colors">
              <Mail className="h-5 w-5 mr-2" />
              support@flatjive.com
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-500">
            &copy; {currentYear} FlatJive Limited (08700039). All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;